import React, {useContext, useEffect} from 'react';

import fakeCustomers from './_fakeCustomers';
import {NextArrow, PrevArrow} from 'components/controls';
import styles from './OurCustomers.scss';
import DoctorReview from '../../Doctors/DoctorReviews/DoctorReview';
import useCarousel from '../../helpers/hooks/useCarousel';
import CustomGrid from '../../controls/grid/CustomGrid';
import {Typography} from '@material-ui/core';
import CustomBox from '../../controls/grid/CustomBox';
import UIContext from '../../../sources/contexts/UiContext';


export default function OurCustomers() {
    const cardPerPage = 1;
    const {data: {isMobile}} = useContext(UIContext);
    //FIXME: Remove long comments on mobile
    const list = fakeCustomers.filter((_, index) => !isMobile || ![7,9].includes(index));
    const carouselLength = Math.floor(list.length / cardPerPage);

    const [
        current,
        handleNext,
        handlePrev,
    ] = useCarousel(1, carouselLength - 1);
    useEffect(() => {
        document.documentElement.style
            .setProperty('--current', isMobile ? current : current - 1);
    }, [current]);
    return (
        <CustomGrid
            container
            justify="center"
            className={styles.wrapperCustomersSection}
        >
            <CustomGrid
                item
                container
                md={8}
                xs={10}
            >
                <CustomBox
                    my="xxl"
                >
                    <Typography
                        variant="h2"
                        color="primary"
                    >
                        {loc('our-customers')}
                    </Typography>
                </CustomBox>
            </CustomGrid>
            <CustomGrid
                item
                md={8}
                xs={10}
                container
            >
                {Array(list.length).fill(null).map((_, idx) => (
                    <CustomGrid item xs={12 / carouselLength} className={idx === current ? styles.activeProgressBar : styles.inactiveProgressBar} key={idx} />
                ))}
            </CustomGrid>
            <div className={styles.carouselWrapper}>
                <div className={styles.gradient} >
                    <PrevArrow className={styles.prev} onClick={handlePrev} />
                    <NextArrow className={styles.next} onClick={handleNext} />
                </div>

                <div className={styles.carousel}>

                    <div className={styles.list}>
                        {list.map(c => (
                            <DoctorReview
                                key={c.id}
                                review={{
                                    patient: {
                                        fullName: `${c.name} ${c.lastName ? c.lastName[0] : ''}`,
                                        avatar: c.avatar,
                                    },
                                    review: c.review,
                                    title: c.title,
                                    rating: 5,
                                }}
                                className={styles.review}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </CustomGrid>
    );
}



// WEBPACK FOOTER //
// ./src/components/Index/sections/OurCustomers.js